import angular = require("angular"); 

import "./homeApp";
import "./unauthorizedApp";
import "./notAllowedApp";


// WEBPACK FOOTER //
// ./IndexApps.ts